import { createAction } from "@reduxjs/toolkit";

// Basic logout action
export const logout = createAction('LOGOUT');

// Enhanced logout action that clears all cached data
export const logoutAndClearCache = createAction('LOGOUT_AND_CLEAR_CACHE');

// Role switch action that clears cache and forces fresh data
export const switchRoleAndClearCache = createAction<string>('SWITCH_ROLE_AND_CLEAR_CACHE');